
import { Button, Col, FormGroup, Modal } from 'react-bootstrap'
import { Card, Container, Label, Row } from 'reactstrap'
import { Breadcrumbs } from '../../AbstractElements'
import React, { useEffect, useState } from 'react';
import {
    User, Mail, Phone, MapPin, Building2, Globe, CreditCard,
    Upload, Save, Camera, CheckCircle2, AlertCircle, IndianRupee,
    DollarSign, Euro
} from 'lucide-react';
import { useLoader } from '../../_helper/LoaderContext';
import { changePassword, cityMaster, districtMaster, getProfileData, logoProfileData, pincodeMaster, stateMaster, updateProfileData } from './service/profile-service';
import { toast } from 'react-toastify';
import { useLab } from '../../_helper/PharmacyProvider';
import { useForm } from 'react-hook-form';
import { Eye, EyeOff, Lock } from "lucide-react";
import { Link } from 'react-router-dom';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import errorProfile from "../../assets/images/blank_profile.png";
import { useLicense } from '../../_helper/LicenseContext';
import Swal from 'sweetalert2';
import S3ImageLoader from '../../S3ImageLoader';
import LoadGoogleMapsAPI from '../LoadGoogleMapsAPI';
import PlacesAutocomplete from 'react-places-autocomplete';
import { useTranslation } from 'react-i18next'


export default function Home() {
    const { t } = useTranslation();
    const { setLoading } = useLoader()
    const [apiData, setApiData] = useState({});
    const { currentLab, setCurrentLab } = useLab();
    const [states, setStates] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [cities, setCities] = useState([]);
    const [pincodes, setPincodes] = useState([]);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [show, setShow] = useState(true);
    const [licenseKey, setLicenseKey] = useState("");
    const { saveLicenseToken } = useLicense()
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);

    const [formData, setFormData] = useState({
        facility_name: "",
        email: "",
        logo: "",
        fName: "",
        mName: "",
        lName: "",
        mobile: "",
        phone_code: "",
        contact_email: "",
        address: "",
        city: "",
        country: "IN",
        state: "",
        district: "",
        pincode: ""
    });
    const [address, setAddress] = useState(formData.address);

    useEffect(() => {
        getData()
    }, [])

    useEffect(() => {
        if (formData.country === "IN") {
            fetchStates();
        } else {
            setStates([]);
            setDistricts([]);
            setCities([]);
            setPincodes([]);
        }
    }, [formData.country]);

    useEffect(() => {
        if (!formData.state) return;

        fetchDistricts(formData.state);

        if (!isInitialLoad) {
            setFormData(prev => ({ ...prev, district: "", city: "", pincode: "" }));
        }
    }, [formData.state]);

    useEffect(() => {
        if (!formData.city) return;

        // fetchPincodes("");

        if (!isInitialLoad) {
            setFormData(prev => ({ ...prev, pincode: "" }));
        }
    }, [formData.city]);

    useEffect(() => {
        if (!formData.state || !formData.district) return;

        fetchCities(formData.state, formData.district);

        if (!isInitialLoad) {
            setFormData(prev => ({ ...prev, city: "", pincode: "" }));
        }
    }, [formData.district]);

    const fetchStates = async (state, district, city, pincode) => {
        setLoading(true)
        try {
            const res = await stateMaster({ country: "India" });
            if (res.data.success) {
                setStates(res.data.data);

                if (state) {
                    await fetchDistricts(state, district, city, pincode);
                }
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false)
        }
    };

    const fetchDistricts = async (state, district, city, pincode) => {
        setLoading(true)
        try {
            const res = await districtMaster({ country: "India", state });
            if (res.data.success) {
                setDistricts(res.data.data);

                if (district) {
                    await fetchCities(state, district, city, pincode);
                }
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    };

    const fetchCities = async (state, district, city, pincode) => {
        setLoading(true)
        try {
            const res = await cityMaster({ country: "India", state, district });
            if (res.data.success) {
                setCities(res.data.data);

                // if (city) {
                //     await fetchPincodes(pincode);
                // }
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    };

    // const fetchPincodes = async (pincode = "") => {
    //     setLoading(true)
    //     try {
    //         const res = await pincodeMaster({ pincode });
    //         if (res.data.success) {
    //             setPincodes(res.data.data);
    //         }
    //     } catch (error) {
    //         console.log(error)
    //     } finally {
    //         setLoading(false)
    //     }
    // };


    const getData = async () => {
        setLoading(true)
        try {
            const res = await getProfileData();
            if (res.data.success == true) {
                const data = res.data.data;
                setApiData(data);
                const cp = data.contact_person;

                setApiData(data);

                setFormData(prev => ({
                    ...prev,
                    facility_name: data.facility_name || "",
                    fName: cp?.first_name || "",
                    mName: cp?.middle_name || "",
                    lName: cp?.last_name || "",
                    mobile: cp?.mobile || "",
                    phone_code: cp?.phone_code || "+91",
                    contact_email: cp?.contact_email || "",
                    address: cp?.address || "",
                    country: cp?.country || "IN",
                    state: cp?.state || "",
                    district: cp?.district || "",
                    city: cp?.city || "",
                    pincode: cp?.pin_code || "",
                }));

                setImageSource(null);

            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false)
        }
    }

    const [logoPreview, setLogoPreview] = useState(``);
    const [labLogoPreview, setLabLogoPreview] = useState(``);
    const [imageFile, setImageFile] = useState(null);
    const [imageSource, setImageSource] = useState(errorProfile);
    const [googleMapApiLoaded, setGoogleMapApiLoaded] = useState(false);
    const [showPassword, setShowPassword] = useState({
        current: false,
        new: false,
        confirm: false,
    });

    const {
        register,
        handleSubmit,
        watch,
        reset,
        formState: { errors, isSubmitting },
    } = useForm();

    // Watch new password for confirmation comparison
    const newPassword = watch("newPassword");

    const togglePasswordVisibility = (field) => {
        setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleLogoChange = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const allowedTypes = [
            'image/jpeg', 'image/jpg', 'image/png',
            'image/tiff', 'image/bpg', 'image/bmp',
            'image/heic', 'image/heif'
        ];

        if (!allowedTypes.includes(file.type)) {
            toast.warning(t("Invalid image format"));
            e.target.value = "";
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            setImageSource(reader.result); // ✅ local preview
        };
        reader.readAsDataURL(file);

        setImageFile(file);
        // const file = e.target.files[0];
        // if (file) {
        //     const reader = new FileReader();
        //     reader.onloadend = () => {
        //         setLogoPreview(reader.result);
        //         setFormData(prev => ({ ...prev, logo: file }));
        //     };
        //     reader.readAsDataURL(file);
        // }
        // setLoading(true)
        // try {
        //     const form_data = new FormData();
        //     form_data.append("profilePicture", file, file.name);
        //     const res = await updateProfileData(form_data, currentLab._id);
        //     if (res.data.success == true) {
        //         toast.success(res.data.message);
        //         localStorage.setItem("currentLab", JSON.stringify(res.data.data))
        //         setCurrentLab(res.data.data);
        //     }
        // } catch (error) {
        //     console.log(error);
        // } finally {
        //     setLoading(false)
        // }
    };

    const handleLabLogoChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setLabLogoPreview(reader.result);
                setFormData(prev => ({ ...prev, logo: file }));
            };
            reader.readAsDataURL(file);
        }
        setLoading(true)
        try {
            const form_data = new FormData();
            form_data.append("logo", file, file.name);
            const res = await logoProfileData(form_data);
            console.log(res)
            if (res.data.success == true) {
                toast.success(res.data.message);
                localStorage.setItem("currentLab", JSON.stringify(res.data.data))
                setCurrentLab(res.data.data);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false)
        }
    };

    const handleSave = async () => {
        setLoading(true)
        try {
            const form_data = new FormData();
            // form_data.append("facility_name", formData.facility_name);
            form_data.append("first_name", formData.fName);
            form_data.append("middle_name", formData.mName);
            form_data.append("last_name", formData.lName);
            form_data.append("phone_code", formData.phone_code || "+91");
            form_data.append("mobile", formData.mobile);
            form_data.append("address", formData.address);
            form_data.append("country", formData.country);
            form_data.append("district", formData.district);
            form_data.append("city", formData.city);
            form_data.append("pin_code", formData.pincode);
            form_data.append("state", formData.state);
            if (imageFile) {
                form_data.append("profilePicture", imageFile, imageFile.name)
            }
            const res = await updateProfileData(form_data, currentLab._id);
            if (res.data.success == true) {
                toast.success(res.data.message);
                localStorage.setItem("currentLab", JSON.stringify(res.data.data));
                setCurrentLab(res.data.data);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false)
        }
    };

    const getCurrencyIcon = (currency) => {
        switch (currency) {
            case 'INR': return <IndianRupee size={18} />;
            case 'USD': return <DollarSign size={18} />;
            case 'EUR': return <Euro size={18} />;
            default: return <Globe size={18} />;
        }
    };

    const onSubmit = async (data) => {
        setLoading(true);
        try {
            setLoading(true)
            try {
                const form_data = new FormData();
                form_data.append("newPassword", data.confirmPassword)
                form_data.append("oldPassword", data.currentPassword)
                const res = await changePassword(form_data);
                if (res.data.success == true) {
                    toast.success(res.data.message);
                    reset();
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false)
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

    const handleSelect = (selectedAddress) => {
        // Log the selected address
        // console.log("Selected Address:", selectedAddress);
        // Update address state
        setAddress(selectedAddress);
        // Use geocoder to get latitude and longitude
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ address: selectedAddress }, (results, status) => {
            console.log("Geocoder Status:", status);

            if (status === 'OK') {
                const location = results[0].geometry.location;
                // console.log("Geocoder Results:", results);
                // console.log("Latitude:", location.lat());
                // console.log("Longitude:", location.lng());
                setFormData(prevValues => ({
                    ...prevValues,
                    address: selectedAddress,
                }));
                // Set latitude and longitude states
                setLatitude(location.lat());
                setLongitude(location.lng());
            } else {
                console.error('Geocode failed:', status);
            }
        });
    };

    const handleInputChanges = (eOrValue, fieldName = null) => {
        if (typeof eOrValue === "object" && eOrValue.target) {
            // Standard input field handling
            const { name, value } = eOrValue.target;

            setFormData((prevValues) => ({
                ...prevValues,
                [name]: value,
            }));
        } else if (fieldName) {
            // Handle custom input like 'PlacesAutocomplete'
            if (fieldName === 'address') {
                setAddress(eOrValue); // Update address state
            }

            setFormData((prevValues) => ({
                ...prevValues,
                [fieldName]: eOrValue,
            }));

            // setFormErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
        }
    }

    return (
        <>
            <Breadcrumbs mainTitle={t("Profile")} parent={t("Home")} title={t("Profile")} />
            <Container>
                <Row>
                    <Col >
                        <div className="row">
                            <div className="col-md-4">
                                {/* Logo & Basic Info */}
                                <Card>
                                    <div className="bg-gradient text-white p-5 position-relative text-center" style={{
                                        background: 'linear-gradient(to right, #667eea, #764ba2)',
                                        borderRadius: '1rem 1rem 0 0'
                                    }}>
                                        <div className="">
                                            <div className="">
                                                <div className="position-relative d-inline-block">
                                                    <S3ImageLoader fileName={currentLab.logo}
                                                        fallbackSrc={errorProfile}
                                                        className="m-0 rounded-circle border border-5 border-white shadow-lg"
                                                        alt={t("Patient")}
                                                        style={{ width: '160px', height: '160px', objectFit: 'cover' }}
                                                    />
                                                    <label
                                                        htmlFor="logo-upload"
                                                        className="position-absolute bottom-0 end-0 bg-primary rounded-circle d-flex justify-content-center align-items-center shadow cursor-pointer"
                                                        style={{
                                                            width: "40px",
                                                            height: "40px",
                                                        }}>
                                                        <Camera size={18} className="text-white tw-cursor-pointer" />
                                                        <input
                                                            id="logo-upload"
                                                            type="file"
                                                            accept="image/*"
                                                            onChange={handleLabLogoChange}
                                                            className="d-none"
                                                        />
                                                    </label>
                                                </div>
                                                <p className="mt-3 mb-0 fw-semibold tw-text-black">{t("Upload Lab Logo")}</p>
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                                <Card className='mt-3'>
                                    <div className="p-4">
                                        <h4 className="tw-text-xl tw-font-bold tw-flex tw-items-center tw-gap-2">
                                            <Lock className="tw-w-6 tw-h-6" />
                                            {t("Change Password")}
                                        </h4>
                                        <form onSubmit={handleSubmit(onSubmit)} className="tw-space-y-6">
                                            {/* Current Password */}
                                            <div>
                                                <label className="tw-block tw-font-medium tw-mb-2">
                                                    {t("Current Password")} <span className="tw-text-red-500">*</span>
                                                </label>
                                                <div className="tw-relative">
                                                    <div className="tw-absolute tw-inset-y-0 tw-left-0 tw-pl-3 tw-flex tw-items-center tw-pointer-events-none">
                                                        <Lock className="tw-w-5 tw-h-5 tw-text-gray-400" />
                                                    </div>
                                                    <input
                                                        type={showPassword.current ? "text" : "password"}
                                                        className="form-control tw-pl-12 tw-pr-12"
                                                        placeholder={t("Enter current password")}
                                                        {...register("currentPassword", {
                                                            required: t("Current password is required"),
                                                        })}
                                                    />
                                                    <span
                                                        // type="span"
                                                        className="tw-absolute tw-inset-y-0 tw-right-0 tw-pr-3 tw-flex tw-items-center"
                                                        onClick={() => togglePasswordVisibility("current")}
                                                    >
                                                        {showPassword.current ? (
                                                            <i className='fa fa-eye tw-cursor-pointer'></i>
                                                        ) : (
                                                            <i className='fa fa-eye-slash tw-cursor-pointer'></i>
                                                        )}
                                                    </span>
                                                </div>
                                                {errors.currentPassword && (
                                                    <p className="tw-text-red-500 tw-text-sm tw-mt-1">
                                                        {errors.currentPassword.message}
                                                    </p>
                                                )}
                                            </div>

                                            {/* New Password */}
                                            <div>
                                                <label className="tw-block tw-font-medium tw-mb-2">
                                                    {t("New Password")} <span className="tw-text-red-500">*</span>
                                                </label>
                                                <div className="tw-relative">
                                                    <div className="tw-absolute tw-inset-y-0 tw-left-0 tw-pl-3 tw-flex tw-items-center tw-pointer-events-none">
                                                        <Lock className="tw-w-5 tw-h-5 tw-text-gray-400" />
                                                    </div>
                                                    <input
                                                        type={showPassword.new ? "text" : "password"}
                                                        className="form-control tw-pl-12 tw-pr-12"
                                                        placeholder={t("Enter new password")}
                                                        {...register("newPassword", {
                                                            required: t("New password is required"),
                                                            minLength: {
                                                                value: 8,
                                                                message: t("Password must be at least 8 characters"),
                                                            },
                                                        })}
                                                    />
                                                    <span
                                                        className="tw-absolute tw-inset-y-0 tw-right-0 tw-pr-3 tw-flex tw-items-center"
                                                        onClick={() => togglePasswordVisibility("new")}
                                                    >
                                                        {showPassword.new ? (
                                                            <i className='fa fa-eye tw-cursor-pointer'></i>
                                                        ) : (
                                                            <i className='fa fa-eye-slash tw-cursor-pointer'></i>
                                                        )}
                                                    </span>
                                                </div>
                                                {errors.newPassword && (
                                                    <p className="tw-text-red-500 tw-text-sm tw-mt-1">
                                                        {errors.newPassword.message}
                                                    </p>
                                                )}
                                            </div>

                                            {/* Confirm New Password */}
                                            <div>
                                                <label className="tw-block tw-font-medium tw-mb-2">
                                                    {t("Confirm New Password")} <span className="tw-text-red-500">*</span>
                                                </label>
                                                <div className="tw-relative">
                                                    <div className="tw-absolute tw-inset-y-0 tw-left-0 tw-pl-3 tw-flex tw-items-center tw-pointer-events-none">
                                                        <Lock className="tw-w-5 tw-h-5 tw-text-gray-400" />
                                                    </div>
                                                    <input
                                                        type={showPassword.confirm ? "text" : "password"}
                                                        className="form-control tw-pl-12 tw-pr-12"
                                                        placeholder={t("Confirm new password")}
                                                        {...register("confirmPassword", {
                                                            required: t("Please confirm your password"),
                                                            validate: (value) =>
                                                                value === newPassword || t("Passwords do not match"),
                                                        })}
                                                    />
                                                    <span
                                                        className="tw-absolute tw-inset-y-0 tw-right-0 tw-pr-3 tw-flex tw-items-center"
                                                        onClick={() => togglePasswordVisibility("confirm")}
                                                    >
                                                        {showPassword.confirm ? (
                                                            <i className='fa fa-eye tw-cursor-pointer'></i>
                                                        ) : (
                                                            <i className='fa fa-eye-slash tw-cursor-pointer'></i>
                                                        )}
                                                    </span>
                                                </div>
                                                {errors.confirmPassword && (
                                                    <p className="tw-text-red-500 tw-text-sm tw-mt-1">
                                                        {errors.confirmPassword.message}
                                                    </p>
                                                )}
                                            </div>

                                            {/* Submit Button */}
                                            <div className="tw-flex tw-justify-end tw-gap-3 tw-pt-4">
                                                <Button
                                                    type="submit"
                                                    color="primary"
                                                    disabled={isSubmitting}
                                                    className="tw-px-8"
                                                >
                                                    {isSubmitting ? t("Changing...") : t("Change Password")}
                                                </Button>
                                                <button
                                                    className='btn btn-secondary'
                                                    type="button"
                                                    onClick={() => reset()}
                                                    disabled={isSubmitting}
                                                >
                                                    {t("Clear")}
                                                </button>

                                            </div>
                                        </form>
                                    </div>
                                </Card>
                            </div>
                            <div className="col-md-8">
                                <Card>
                                    <div className="">
                                        <div className="">
                                            <div className="">
                                                <div className="p-4">
                                                    <form onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
                                                        <div className="row g-4">
                                                            {/* Lab Details */}
                                                            <div className="col-12">
                                                                <h5 className="fw-bold mb-3">
                                                                    <Building2 className="me-2" size={20} /> {t("Laboratory Information")}
                                                                </h5>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <label className="form-label fw-semibold">{t("Facility Name")}</label>
                                                                <input
                                                                    type="text"
                                                                    name="facility_name"
                                                                    value={formData.facility_name}
                                                                    onChange={handleInputChange}
                                                                    className="form-control form-control-lg"
                                                                    placeholder={t("Enter lab name")}
                                                                />
                                                            </div>
                                                            <div className="col-md-4">
                                                                <label className="form-label fw-semibold">{t("Base Currency")}</label>
                                                                <select className="form-select form-select-lg" value={apiData?.baseCurrency || ""} disabled>
                                                                    {apiData?.allowedCurrencies?.map(curr => (
                                                                        <option key={curr} value={curr}>{curr}</option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            {/* Contact Person */}
                                                            <div className="col-12 mt-4">
                                                                <h5 className="fw-bold mb-3">
                                                                    <User className="me-2" size={20} /> {t("Contact Person Details")}
                                                                </h5>
                                                            </div>
                                                            <div className="col-md-6" style={{ marginTop: "45px" }}>
                                                                <input
                                                                    id="logo-upload"
                                                                    type="file"
                                                                    accept="image/*"
                                                                    onChange={handleLogoChange}
                                                                    className="form-control"
                                                                />
                                                            </div>
                                                            <div className="col-md-6">
                                                                {/* Profile Image Preview */}
                                                                <div className="col-md-2">
                                                                    {imageSource ? (
                                                                        // ✅ Show newly selected image immediately
                                                                        <img
                                                                            src={imageSource}
                                                                            alt={t("Profile Preview")}
                                                                            className="frame-box"
                                                                            style={{ height: '75px', width: '100%', objectFit: 'cover' }}
                                                                            onError={(e) => (e.target.src = errorProfile)}
                                                                        />
                                                                    ) : (
                                                                        // ✅ Show image from API / S3
                                                                        <S3ImageLoader
                                                                            className="frame-box"
                                                                            fileName={currentLab?.contact_person?.profile_picture}
                                                                            style={{ height: '75px', width: '100%', objectFit: 'cover' }}
                                                                            alt={t("Profile")}
                                                                            fallbackSrc={errorProfile}
                                                                        />
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <label className="form-label fw-semibold">{t("First Name")}</label>
                                                                <input
                                                                    type="text"
                                                                    name="fName"
                                                                    value={formData.fName}
                                                                    onChange={handleInputChange}
                                                                    className="form-control form-control-lg"
                                                                />
                                                            </div>
                                                            <div className="col-md-4">
                                                                <label className="form-label fw-semibold">{t("Middle Name")}</label>
                                                                <input
                                                                    type="text"
                                                                    name="mName"
                                                                    value={formData.mName}
                                                                    onChange={handleInputChange}
                                                                    className="form-control form-control-lg"
                                                                />
                                                            </div>
                                                            <div className="col-md-4">
                                                                <label className="form-label fw-semibold">{t("Last Name")}</label>
                                                                <input
                                                                    type="text"
                                                                    name="lName"
                                                                    value={formData.lName}
                                                                    onChange={handleInputChange}
                                                                    className="form-control form-control-lg"
                                                                />
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label className="form-label fw-semibold">{t("Contact Email")}</label>
                                                                <input
                                                                    type="email"
                                                                    name="contact_email"
                                                                    value={formData.contact_email}
                                                                    onChange={handleInputChange}
                                                                    className="form-control form-control-lg"
                                                                />
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label className="form-label fw-semibold">{t("Mobile Number")}</label>
                                                                <PhoneInput
                                                                    country={"in"}
                                                                    value={formData.mobile ? `${formData.phone_code}${formData.mobile}` : ""}
                                                                    onChange={(phone, countryData) => {
                                                                        const nationalNumber = phone.slice(countryData.dialCode.length); // removes dial code
                                                                        const dialCode = `+${countryData.dialCode}`;
                                                                        setFormData(prev => ({
                                                                            ...prev,
                                                                            mobile: nationalNumber || "",
                                                                            phone_code: dialCode
                                                                        }));
                                                                    }}
                                                                    inputProps={{
                                                                        name: "mobile",
                                                                        required: true,
                                                                        className: "form-control form-control-lg"
                                                                    }}
                                                                    enableSearch={true}
                                                                    searchPlaceholder={t("Search country")}
                                                                />
                                                            </div>
                                                            <div className="col-12">
                                                                {/* <label className="form-label fw-semibold">Address</label>
                                                                <input
                                                                    type="text"
                                                                    name="address"
                                                                    value={formData.address}
                                                                    onChange={handleInputChange}
                                                                    className="form-control form-control-lg"
                                                                /> */}
                                                                <FormGroup>
                                                                    <Label className='mb-2' for="address">{t("Address")}</Label>
                                                                    <LoadGoogleMapsAPI onLoad={() => setGoogleMapApiLoaded(true)} />

                                                                    {googleMapApiLoaded && (
                                                                        <PlacesAutocomplete
                                                                            value={formData.address}
                                                                            onChange={(value) => handleInputChanges(value, 'address')}
                                                                            onSelect={handleSelect}
                                                                        >
                                                                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                                                <div>
                                                                                    <input
                                                                                        {...getInputProps({
                                                                                            className: "form-control input-font-size",
                                                                                            placeholder: t("Enter Address"),
                                                                                            id: "address",
                                                                                            name: "address",
                                                                                            type: "text",
                                                                                        })}
                                                                                    />
                                                                                    {loading && <div className="loading-indicator">{t("Loading...")}</div>}
                                                                                    {suggestions.length > 0 && (
                                                                                        <div className="suggestions-list" style={{
                                                                                            border: "1px solid #ccc",
                                                                                            borderRadius: "4px",
                                                                                            maxHeight: "200px",
                                                                                            overflowY: "auto",
                                                                                            position: "absolute",
                                                                                            width: "100%",
                                                                                            zIndex: 100,
                                                                                        }}>
                                                                                            {suggestions.map((suggestion, index) => (
                                                                                                <div
                                                                                                    key={index}
                                                                                                    {...getSuggestionItemProps(suggestion)}
                                                                                                    className="suggestion-item"
                                                                                                    style={{
                                                                                                        padding: "8px",
                                                                                                        cursor: "pointer",
                                                                                                    }}
                                                                                                >
                                                                                                    {suggestion.description}
                                                                                                </div>
                                                                                            ))}
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                        </PlacesAutocomplete>
                                                                    )}

                                                                </FormGroup>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label className="form-label fw-semibold">{t("Country")}</label>
                                                                <select
                                                                    name="country"
                                                                    value={formData.country}
                                                                    onChange={handleInputChange}
                                                                    className="form-select form-select-lg"
                                                                >
                                                                    <option value="IN">{t("India")}</option>
                                                                    <option value="AE">{t("UAE")}</option>
                                                                    <option value="US">{t("USA")}</option>
                                                                </select>
                                                            </div>
                                                            {/* <div className="col-md-6"> */}
                                                            {formData.country === "IN" && (
                                                                <div className="col-md-6">
                                                                    <label className="form-label fw-semibold">{t("State")}</label>
                                                                    <select
                                                                        className="form-select form-select-lg"
                                                                        value={formData.state}
                                                                        onChange={(e) =>
                                                                            setFormData(prev => ({ ...prev, state: e.target.value }))
                                                                        }
                                                                    >
                                                                        <option value="">{t("Select State")}</option>
                                                                        {states.map(s => (
                                                                            <option key={s._id} value={s.State}>
                                                                                {s.State}
                                                                            </option>
                                                                        ))}
                                                                    </select>

                                                                </div>
                                                            )}
                                                            {/* </div> */}
                                                            <div className="col-md-6">
                                                                <label className="form-label fw-semibold">{t("District")}</label>
                                                                <select
                                                                    className="form-select form-select-lg"
                                                                    value={formData.district}
                                                                    onChange={(e) =>
                                                                        setFormData(prev => ({ ...prev, district: e.target.value }))
                                                                    }
                                                                    disabled={!formData.state}
                                                                >
                                                                    <option value="">{t("Select District")}</option>
                                                                    {districts.map(d => (
                                                                        <option key={d._id} value={d.District}>
                                                                            {d.District}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <label className="form-label fw-semibold">{t("City")}</label>
                                                                <select
                                                                    className="form-select form-select-lg"
                                                                    value={formData.city}
                                                                    onChange={(e) =>
                                                                        setFormData(prev => ({ ...prev, city: e.target.value }))
                                                                    }
                                                                    disabled={!formData.district}
                                                                >
                                                                    <option value="">{t("Select City")}</option>
                                                                    {cities.map(c => (
                                                                        <option key={c._id} value={c.City}>
                                                                            {c.City}
                                                                        </option>
                                                                    ))}

                                                                </select>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label className="form-label fw-semibold">{t("Pincode")}</label>
                                                                <input
                                                                    type="text"
                                                                    name="pincode"
                                                                    value={formData.pincode}
                                                                    onChange={handleInputChange}
                                                                    className="form-control form-control-lg"
                                                                    placeholder={t("Enter pincode")}
                                                                />
                                                                {/* <select
                                                                    className="form-select form-select-lg"
                                                                    value={formData.pincode}
                                                                    onChange={(e) =>
                                                                        setFormData(prev => ({ ...prev, pincode: e.target.value }))
                                                                    }
                                                                    disabled={!formData.city}
                                                                >
                                                                    <option value="">Select Pincode</option>
                                                                    {pincodes.map(p => (
                                                                        <option key={p._id} value={p.pincode}>
                                                                            {p.pincode}
                                                                        </option>
                                                                    ))}

                                                                </select> */}
                                                            </div>


                                                            <div className="col-12 text-end mt-5">
                                                                <button
                                                                    type="submit"
                                                                    className="btn btn-primary me-3"
                                                                >
                                                                    {t("Update")}
                                                                </button>
                                                                <Link to={`${process.env.PUBLIC_URL}/dashboard`}>
                                                                    <button className='btn btn-secondary' type="button">{t("Cancel")}</button>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>

        </>
    )
}
